import {PositionEntityModel} from "../position-entity.model";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    "selector": "wbo-postion-edit-page",
    "templateUrl": "./position-edit-page.component.html",
    providers: [provideEntityModel(PositionEntityModel)]
})
export class PositionEditPageComponent extends AbstractEditPage {
    constructor(public model: PositionEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
